import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
	palette: {
		type: 'dark',
		secondary: {
			// main: '#e57373'
			main: '#f06292'
			// main: '#ff8a65'
		}
	},
	
});

export default theme;